export const parseCronExpression = (expression: string) => {
  if (!expression) return null;
  const parts = expression.trim().split(" ");
  if (parts.length !== 5) return null;
  const [minute, hour, dayOfMonth, month, dayOfWeek] = parts;
  return {
    minute,
    hour,
    dayOfMonth,
    month,
    dayOfWeek,
    raw: parts,
  };
};
export const hasMultipleValues = (cronPart: string): boolean => {
  return cronPart.includes(",");
};
export const extractNumbers = (cronPart: string): number[] => {
  if (cronPart === "*") return [];
  if (cronPart.includes(",")) {
    return cronPart.split(",").map((num) => parseInt(num.trim()));
  }
  if (cronPart.includes("/")) {
    const [, interval] = cronPart.split("/");
    return [parseInt(interval)];
  }
  return [parseInt(cronPart)];
};
export const createCronInitializer = (setters: any, dayjs: any) => {
  const initializeHourlyTab = (minute: string, hour: string) => {
    const minuteValue = parseInt(minute) || 0;
    setters.setMinute(minuteValue);
    if (hour.includes("/")) {
      const [, interval] = hour.split("/");
      const hourInterval = parseInt(interval) || 1;
      const selectedHour = dayjs().set("hour", hourInterval).set("minute", 0);
      setters.setSelectedHour(selectedHour);
    } else if (hour !== "*") {
      const hourValue = parseInt(hour) || 0;
      const selectedHour = dayjs().set("hour", hourValue).set("minute", 0);
      setters.setSelectedHour(selectedHour);
    }
  };
  const initializeDailyTab = (minute: string, hour: string) => {
    const minuteValue = parseInt(minute) || 0;
    const hourValue = parseInt(hour) || 0;
    if (hasMultipleValues(minute) || hasMultipleValues(hour)) {
      setters.setSelectedValue("Repeat");
      const selectedTime = dayjs()
        .set("hour", hourValue)
        .set("minute", minuteValue);
      setters.setSelectedPerDayRepeatTime(selectedTime);
      if (hasMultipleValues(hour)) {
        const hours = extractNumbers(hour);
        setters.setSelectedTimesPerDay(hours.length);
        if (hours.length > 1) {
          const gap = hours[1] - hours[0];
          setters.setDailyGap(gap);
          setters.setDailyGapUnit("hours");
        }
      } else if (hasMultipleValues(minute)) {
        const minutes = extractNumbers(minute);
        setters.setSelectedTimesPerDay(minutes.length);
        if (minutes.length > 1) {
          const gap = minutes[1] - minutes[0];
          setters.setDailyGap(gap);
          setters.setDailyGapUnit("minutes");
        }
      }
    } else {
      setters.setSelectedValue("RepeatEveryDay");
      const selectedTime = dayjs()
        .set("hour", hourValue)
        .set("minute", minuteValue);
      setters.setSelectedEveryDayRepeatTime(selectedTime);
      setters.setValue(selectedTime);
      setters.setFormattedRepeatEveryDayTime(selectedTime.format("hh:mm A"));
      setters.setRepeatEveryDayTimeSelected(true);
    }
  };
  const initializeWeeklyTab = (
    minute: string,
    hour: string,
    dayOfWeek: string
  ) => {
    const minuteValue = parseInt(minute) || 0;
    const hourValue = parseInt(hour) || 0;
    const selectedTime = dayjs()
      .set("hour", hourValue)
      .set("minute", minuteValue);
    setters.setSelectedWeekTime(selectedTime);
    setters.setValue(selectedTime);
    setters.setWeeklyTimeSelected(true);
    if (dayOfWeek !== "*") {
      const days = extractNumbers(dayOfWeek);
      setters.setSelectedDaysOfWeek(days);
    }
    setters.setSelectedWeeks(1);
  };
  const initializeMonthlyTab = (
    minute: string,
    hour: string,
    dayOfMonth: string,
    month: string
  ) => {
    const minuteValue = parseInt(minute) || 0;
    const hourValue = parseInt(hour) || 0;
    const dayValue = parseInt(dayOfMonth) || 1;
    const selectedTime = dayjs()
      .set("hour", hourValue)
      .set("minute", minuteValue);
    setters.setSelectedMonthTime(selectedTime);
    setters.setSelectedMonthsTime(selectedTime);
    setters.setSelectMonthTime(selectedTime);
    setters.setSelectedDay(dayValue);
    const selectedDate = dayjs().set("date", dayValue);
    setters.setSelectedDate(selectedDate);
    setters.setSelectMonthDate(selectedDate);
    if (month.includes("/")) {
      const [, interval] = month.split("/");
      const monthInterval = parseInt(interval) || 1;
      setters.setEveryValue(monthInterval);
    } else {
      setters.setEveryValue(1);
    }
  };
  return {
    initializeHourlyTab,
    initializeDailyTab,
    initializeWeeklyTab,
    initializeMonthlyTab,
  };
};
